import React from "react";
import img from "../../assets/icons/python.png";

function SocialMedia() {
  return (
    <div
      style={{
        background: "#f9f9f9",
        borderRadius: "12px",
        boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
        padding: "30px",
        width: "100%",
        maxWidth: "450px",
        animation: "fadeIn 1s ease-in-out",
        textAlign: "center",
      }}
    >
      <img
        src={img}
        alt="Python"
        style={{
          width: "120px",
          height: "120px",
          marginBottom: "20px",
          borderRadius: "50%",
          border: "4px solid #ddd",
        }}
      />
      <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "bold" }}>
        Let's Connect
      </h2>
      <p style={{ color: "#555", marginBottom: "25px", fontSize: "16px" }}>
        Reach out to me on any of these platforms!
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
        }}
      >
        <a
          href="https://www.linkedin.com/in/felix-owusu-9a349922b"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "#0073b1",
            fontSize: "18px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            padding: "10px 20px",
            border: "1px solid #0073b1",
            borderRadius: "8px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#0073b1";
            e.target.style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent";
            e.target.style.color = "#0073b1";
          }}
        >
          <i className="fab fa-linkedin"></i> LinkedIn
        </a>
        <a
          href="https://web.whatsapp.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "#25D366",
            fontSize: "18px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            padding: "10px 20px",
            border: "1px solid #25D366",
            borderRadius: "8px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#25D366";
            e.target.style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent";
            e.target.style.color = "#25D366";
          }}
        >
          <i className="fab fa-whatsapp"></i> WhatsApp
        </a>
        <a
          href="https://www.instagram.com/fel_ixowusu/profilecard/?igsh=aHA3cm9jNWFydG9s"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "#E4405F",
            fontSize: "18px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            padding: "10px 20px",
            border: "1px solid #E4405F",
            borderRadius: "8px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#E4405F";
            e.target.style.color = "#fff";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent";
            e.target.style.color = "#E4405F";
          }}
        >
          <i className="fab fa-instagram"></i> Instagram
        </a>
      </div>

      {/* Custom Animation */}
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
}

export default SocialMedia;
